import { useEffect } from 'react';
// @ts-expect-error
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export type ExportPdfEvent<T = string> = {
  source: T;
  success: boolean;
  message: string;
  error?: any;
};

export const useAutoExportPdf = ({
  source,
  autoExport,
  pageLoaded,
  ressourceLoaded,
  exportPdf,
  onSuccess,
  onFailed,
}: {
  source: string;
  autoExport: boolean;
  pageLoaded: boolean;
  ressourceLoaded: boolean;
  exportPdf: () => Promise<void>;
  onSuccess?: () => void;
  onFailed?: () => void;
}) => {
  const [searchParams] = useSearchParams();

  const dispatchEventParentWindow = (event: Omit<ExportPdfEvent, 'source'>) => {
    if (!window.opener) {
      return;
    }
    window.opener.postMessage(
      {
        source,
        ...event,
      } satisfies ExportPdfEvent,
      window.location.origin,
    );
  };

  useEffect(() => {
    if (!autoExport || !pageLoaded || !ressourceLoaded) {
      return;
    }

    exportPdf()
      .then(() => {
        dispatchEventParentWindow({
          success: true,
          message: 'Pdf generated success',
        });
        onSuccess?.();
      })
      .catch((error: any) => {
        dispatchEventParentWindow({
          success: false,
          message: 'Pdf generated failed',
          error,
        });
        onFailed?.();
      });
  }, [autoExport, pageLoaded, ressourceLoaded, searchParams]);
};
